/**
 * Free-flow search — modal only, no /search page navigation.
 */
(function () {
  if (window.__straightSearchBound) return;

  function redirectSearchTemplate() {
    if (!document.body.classList.contains('template-search')) return false;
    if (document.documentElement.classList.contains('shopify-design-mode')) return false;

    const params = new URLSearchParams(window.location.search);
    const q = params.get('q') || '';
    const dest = new URL('/', window.location.origin);
    dest.searchParams.set('openSearch', '1');
    if (q) dest.searchParams.set('q', q);
    window.location.replace(dest.pathname + dest.search);
    return true;
  }

  if (redirectSearchTemplate()) return;

  window.__straightSearchBound = true;

  function isHomepage() {
    const main = document.querySelector('#MainContent');
    return (
      document.body.classList.contains('template-index') ||
      main?.dataset.template === 'index'
    );
  }

  function searchModal() {
    return document.getElementById('search-modal');
  }

  function searchForm() {
    return document.querySelector('#search-modal .predictive-search-form');
  }

  function readQuery() {
    return (searchForm()?.querySelector('[name="q"]')?.value || '').trim();
  }

  function closeSearchModal() {
    const modal = searchModal();
    if (modal && typeof modal.closeDialog === 'function') modal.closeDialog();
  }

  function openSearchModal(query) {
    const modal = searchModal();
    if (!modal || typeof modal.showDialog !== 'function') return;

    modal.showDialog();

    const input = modal.querySelector('.search-input');
    if (!input) return;

    if (query) {
      input.value = query;
      input.dispatchEvent(
        new InputEvent('input', { bubbles: true, inputType: 'insertText', data: query })
      );
    } else {
      window.setTimeout(() => input.focus(), 50);
    }
  }

  function applyBrowseSearch(query) {
    const q = (query || '').trim();
    closeSearchModal();

    if (window.StraightBrowseAll && typeof window.StraightBrowseAll.applySearchQuery === 'function') {
      window.StraightBrowseAll.applySearchQuery(q);
      return;
    }

    const target = document.getElementById('browse-all-products');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function bindSearchForm() {
    const form = searchForm();
    if (!form || form.dataset.straightSearchBound === 'true') return;
    form.dataset.straightSearchBound = 'true';

    form.addEventListener('submit', (e) => {
      if (!isHomepage()) return;
      e.preventDefault();
      applyBrowseSearch(readQuery());
    });

    const viewAll = form.querySelector('.predictive-search__search-button');
    if (viewAll) {
      viewAll.type = 'button';
      viewAll.addEventListener('click', () => {
        if (!isHomepage()) return;
        applyBrowseSearch(readQuery());
      });
    }
  }

  function consumeOpenSearchParam() {
    if (!isHomepage()) return;

    const params = new URLSearchParams(window.location.search);
    if (params.get('openSearch') !== '1') return;

    const q = params.get('q') || '';
    params.delete('openSearch');
    params.delete('q');

    const clean = params.toString();
    const nextUrl = window.location.pathname + (clean ? '?' + clean : '') + window.location.hash;
    window.history.replaceState(null, '', nextUrl);

    window.setTimeout(() => {
      if (q) {
        applyBrowseSearch(q);
      } else {
        openSearchModal('');
      }
    }, 0);
  }

  document.addEventListener('straight:search:apply', (e) => {
    applyBrowseSearch(e.detail && e.detail.query != null ? e.detail.query : readQuery());
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      bindSearchForm();
      consumeOpenSearchParam();
    });
  } else {
    bindSearchForm();
    consumeOpenSearchParam();
  }
})();
